'use strict';

module.exports = function macro(name, fn) {
  this.constructor.prototype[name] = fn;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/macro.js
// module id = 1242
// module chunks = 2